import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLocalization } from "./Localization/Localization";
import CloseIcon from "../assets/img/close-icon.svg";

function DeleteAlertBox(props) {
  const { t } = useLocalization();
  const [heading, setHeading] = useState("");
  useEffect(() => {
    if (props.show) {
      setHeading(props.heading);
    }
  }, [props.show]);

  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="modasss"
        centered
      >
        <Modal.Body>
          <div className="login-box">
            <button onClick={() => props.onHide()} className="btn-btn-close">
              <img src={CloseIcon} alt="" />
            </button>
            {heading !== "" ? (
              <h4>{heading}</h4>
            ) : (
              <h4>Are you sure You want to delete this Leave Request</h4>
            )}

            <button
              className="btn-btn-primary"
              onClick={(e) => {
                e.preventDefault();
                props?.CallDeleteApi();
              }}
            >
              {t("yes")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DeleteAlertBox;
